import type { MigrationRunStatus } from '@modules/Clients/ViewClient/adapters/MigrationApiAdapter';
import type { LegacyPaymentProfile } from './LegacyDashboardClient';

export type BooleanFilter = 'all' | 'yes' | 'no';
export type MigrationFilter = 'all' | 'migrated' | 'not_migrated';

export interface LegacyDashboardFilters {
  migrationFilter: MigrationFilter;
  paymentProfiles: LegacyPaymentProfile[];
  shopChannels: string[];
  countryCodes: string[];
  migrationRunStatuses: MigrationRunStatus[];
  verified: BooleanFilter;
  isDropshipping: BooleanFilter;
  crmActive: BooleanFilter;
  minOrdersCount: number | null;
  maxOrdersCount: number | null;
  minAvgOrdersPerMonth: number | null;
  maxAvgOrdersPerMonth: number | null;
}

export const DEFAULT_LEGACY_DASHBOARD_FILTERS: LegacyDashboardFilters = {
  migrationFilter: 'all',
  paymentProfiles: [],
  shopChannels: [],
  countryCodes: [],
  migrationRunStatuses: [],
  verified: 'all',
  isDropshipping: 'all',
  crmActive: 'all',
  minOrdersCount: null,
  maxOrdersCount: null,
  minAvgOrdersPerMonth: null,
  maxAvgOrdersPerMonth: null,
};
